import { useSearchProducts } from "./products/products.mjs";
import { debounce } from "lodash-es";
import { computed, ref, watch } from "vue";
export function useSearchProduct(initialValue = "", opts = {
  passive: true
}) {
  const confirmedSearchWord = ref("");
  const searchBy = ref(initialValue);
  const searchByQueryParam = ref("");
  const {
    products: result,
    execute,
    isFetching,
    categoriesResult
  } = useSearchProducts(
    computed(() => ({
      page: 1,
      pageSize: 15,
      search: searchByQueryParam.value
    })),
    {
      fetchOnMount: !opts?.passive
    }
  );
  watch(
    searchBy,
    debounce((value) => {
      confirmedSearchWord.value = value;
      searchByQueryParam.value = value;
    }, 400),
    {
      immediate: true
    }
  );
  return {
    searchBy,
    result,
    execute,
    isFetching,
    categoriesResult,
    confirmedSearchWord
  };
}
